/**
 * Premissas do simulador: o padrão vem do mercado e o vendedor pode trocar.
 *
 * Decisão do Rick (16/10): o vendedor ajusta as taxas, mas toda premissa nasce
 * de uma fonte de verdade — o Banco Central (SGS) quando existe série oficial.
 * Ágio de carta contemplada não tem índice oficial; aí o padrão é a referência
 * da North (AGIO_PADRAO_PCT) e a tela diz isso.
 *
 * Os indicadores são buscados UMA vez por simulador (useIndicadoresMercado) e
 * repassados; enquanto o BCB não responde, vale o PADRAO datado — nenhum número
 * da tela espera a rede para aparecer.
 */
import { useEffect, useState } from 'react';
import { PADRAO, carregarIndicadores, type Indicadores } from './indicadoresBcb';
import { FONTE_INFORMADA, type ValorDeMercado } from '../../../../../db/supabase/functions/_shared/apresentacao/premissas.ts';

// Valores de mercado e a montagem das opções: parte pura, dividida com a North IA.
export * from '../../../../../db/supabase/functions/_shared/apresentacao/premissas.ts';

export const useIndicadoresMercado = (): Indicadores => {
  const [indicadores, setIndicadores] = useState<Indicadores>({ ...PADRAO, fonte: 'padrao' });
  useEffect(() => {
    let vivo = true;
    carregarIndicadores().then((ind) => {
      if (vivo) setIndicadores(ind);
    });
    return () => {
      vivo = false;
    };
  }, []);
  return indicadores;
};

export type Premissa = {
  valor: number;
  mercado: ValorDeMercado;
  /** true quando o vendedor digitou um valor diferente do de mercado. */
  editado: boolean;
  definir: (v: number) => void;
  restaurar: () => void;
};

export const usePremissa = (mercado: ValorDeMercado): Premissa => {
  const [manual, setManual] = useState<number | null>(null);
  return {
    valor: manual ?? mercado.valor,
    mercado,
    editado: manual !== null && manual !== mercado.valor,
    definir: setManual,
    restaurar: () => setManual(null),
  };
};

/** Fonte que vai para o PDF: a do mercado, ou "informado" se o vendedor trocou. */
export const fonteDaPremissa = (p: Premissa): string => (p.editado ? FONTE_INFORMADA : p.mercado.fonte);
